export let StatusEnum;

(function (StatusEnum) {
  StatusEnum["Paid"] = "paid";
  StatusEnum["Failed"] = "failed";
})(StatusEnum || (StatusEnum = {}));

export let PayoutInvoiceType;

(function (PayoutInvoiceType) {
  PayoutInvoiceType["Payment"] = "Payment";
  PayoutInvoiceType["Refund"] = "Refund";
  PayoutInvoiceType["Dispute"] = "Dispute";
})(PayoutInvoiceType || (PayoutInvoiceType = {}));